// action names
export const SAVE_LANE_INFO = 'savelaneoilconditions'
export const SAVE_EVENT_INFO = 'saveeventinfo'
export const SAVE_EVENT_DETAILS = 'saveeventdetails'
export const SAVE_LANE_CONDITIONS = 'saveeventlaneconditions'
export const SAVE_EVENT_SETUP = 'saveeventsetup'
export const SAVE_EVENT_SETUP_ERROR = 'saveeventsetuperror'
export const FETCH_CENTER = 'fetchcenter'
export const FETCH_MEMBER = 'fetchmember'
export const FETCH_TOURNAMENTS = 'fetchtournaments'
export const FETCH_TOURNAMENT = 'fetchtournament'




export const DELETE_EVENT = 'deleteevent'
export const CANCEL_EVENT = 'deleteevent'
export const SET_EVENT_TYPE = 'seteventtype'
export const SAVE_EVENT_CERT_NUMBER = 'saveeventcertificationnumber'
export const SET_WIZARD_STEP = 'setwizardstep'
export const FETCH_ORPHANED_EVENTS = 'fetchorphanedevents'
export const FETCH_COMPLETED_EVENTS = 'fetchcompletedevents'
export const RESET_RETRIEVED_EVENT = 'resetretrievedevent'
export const SET_CERTIFICATION_NUMBER = 'setCertNumber'
export const SET_SELECTED_SCHOOL = 'setselectedschool'
export const SET_USER_ROLE = 'setuserrole'



const modules = {
  season: 'season/',
  event: 'event/',
  postevent: 'postevent/'
}
const { season, event, postevent } = modules

export const RESET_EVENT_WIZARD = 'reseteventwizard'

export const fileUpload = {
  UPLOAD_EVENT_RESULTS: 'uploadeventresults',
  SET_EVENT_RESULTS_FILENAME: 'seteventresultsfilename',
  RESET_EVENT_RESULTS_FILE: 'reseteventresultsfile',
  UPLOADING_RESULTS_FILE: 'uploadingresultsfile',
  WRONG_FILE_UPLOAD_TYPE: 'wrongfileuploadtype',
  RESET_UPLOAD_ERROR_MESSAGE: 'resetuploaderrormessage'
}
export const user = {
  CHECK_USER_ROLE: '/user/inrole/rolename',
  SET_USER_ROLE: 'user/setrole',
  GET_USER_ROLE: 'user/USERROLE',
  CHECKING_USER_ROLE: 'user/CHECKING_USERROLE'
}
export const types = {
  Season: {
    FETCH_ACTIVE_SEASONS: `${season}FETCH_ACTIVE_SEASONS`,
    FETCH_NEW_SEASON: `${season}FETCH_NEW_SEASON`,
    FETCH_SEASON_DATES: `${season}FETCH_SEASON_DATES`,
    SAVE_SEASON_DATES: `${season}SAVE_SEASON_DATES`,
    SAVE_SEASON_OILCONDITIONS: `${season}SAVE_SEASON_OILCONDITIONS`,
    SAVE_SEASON_SETUP: `${season}SAVE_SEASON_SETUP`,
    SAVE_SEASON_DIVISION: `${season}SAVE_SEASON_DIVISION`,
    ADD_SEASON_DIVISION: `${season}ADD_SEASON_DIVISION`,
    ADDING_SEASON_DIVISION: `${season}ADDING_SEASON_DIVISION`,
    ADD_DIVISION_MODE: `${season}ADD_DIVISION_MODE`,
    DELETE_SEASON_DIVISION: `${season}DELETE_SEASON_DIVISION`,
    SAVE_SEASON_FEE: `${season}SAVE_SEASON_FEE`,
    SAVE_SEASON_PARTICIPANT: `${season}SAVE_SEASON_PARTICIPANT`,
    SAVING_SEASON_PARTICIPANT: `${season}SAVING_SEASON_PARTICIPANT`,
    SAVE_EMAIL_SETTINGS: `${season}SAVE_EMAIL_SETTINGS`,
    SAVING_EMAIL_SETTINGS: `${season}SAVING_EMAIL_SETTINGS`,
    SAVING_DATA: `${season}SAVING_DATA`,
    SAVING_SEASON_OIL: `${season}SAVING_SEASON_OIL`,
    SAVING_SEASON_SETUP: `${season}SAVING_SEASON_SETUP`,
    SAVING_SEASON_DIVISION: `${season}SAVING_SEASON_DIVISION`,
    TRIGGER_SEASON: `${season}TRIGGER_SEASON`,
    RESET_DATES_SETTINGS: `${season}RESET_DATES_SETTINGS`,
    RESET_OIL_SETTINGS: `${season}RESET_OIL_SETTINGS`,
    RESET_SETUP_SETTINGS: `${season}RESET_SETUP_SETTINGS`,
    RESET_PARTICIPANT_SETTINGS: `${season}RESET_PARTICIPANT_SETTINGS`,
    RESET_TEMPLATE_SETTINGS: `${season}RESET_TEMPLATE_SETTINGS`
  },
  Event: {
    SET_CENTER: `${event}setcenter`,
    RESET_EVENT_WIZARD: `${event}reseteventwizard`,
    SAVE_EVENT_INFO: `${event}saveeventinfo`,
    SAVE_EVENT_INFO_ERROR: `${event}saveeventinfoerror`,
    SAVE_EVENT_DETAILS: `${event}saveeventdetails`,
    SAVE_EVENT_DETAILS_ERROR: `${event}saveeventdetailserror`,
    SAVING_EVENT_OIL_CONDITIONS: `${event}savingeventoilconditions`,
    SAVE_EVENT_OIL_CONDITIONS: `${event}saveeventoilconditions`,
    SAVE_EVENT_OIL_CONDITIONS_ERROR: `${event}saveeventoilconditionserror`,
    SAVE_EVENT_SETUP: `${event}saveeventsetup`,
    SAVE_EVENT_SETUP_ERROR: `${event}saveeventsetuperror`,
    RESET_DIVISIONS_OFFERED: `${event}resetdivisionsoffered`,
    SAVE_EVENT_DEPOSIT: `${event}saveeventdeposit`,
    SAVING_EVENT_DEPOSIT: `${event}savingeventdeposit`,
    SAVE_EVENT_DEPOSIT_ERROR: `${event}saveeventdepositerror`,
    UPLOAD_RULES_FILE: `${event}uploadrulesfile`,
    UPLOADING_RULES_FILE: `${event}uploadingrulesfile`,
    RULES_PENDING_APPROVAL: `${event}rulespendingapproval`,
    APPROVE_EVENT_RULES: `${event}approveeventrules`,
    DENY_EVENT_RULES: `${event}denyeventrules`,
    ADD_MIXED_AGE_DIVISION: `${event}addmixedagedivision`,
    SET_EVENT_TYPE: `${event}seteventtype`,
    SET_DEFAULT_WEEKS: `${event}setdefaultweeks`,
    SET_DEFAULT_EVENT_SEASON: `${event}setdefaulteventseason`,
    SET_OIL_RATIO: `${event}setoilratio`,
    INIT_OIL_RATIO: `${event}initoilratio`,
    FETCH_MEMBER: `${event}fetchmember`,
    FETCH_EVENT: `${event}fetchevent`,
    FETCHING_EVENT: `${event}fetchingevent`,
    RESET_WIZARD_STATE: `${event}resetwizardstate`,
    RESET_EVENT_STATE: `${event}reseteventstate`,
    DELETE_EVENT: `${event}deleteevent`,
    CANCEL_EVENT: `${event}cancelevent`,
    COPY_EVENT: `${event}copyevent`,
    PRESTINE_NAVIGATE_NEXT: `${event}prestinenavigatenext`,
    SET_SEARCH_MODE: `${event}searchmode`,
    TRANSFER_FUNDS: `${event}transferfunds`,
    TRANSFERRING_FUNDS: `${event}transferringfunds`,
    ADJUST_FUNDS: `${event}adjustfunds`,
    ADJUSTING_FUNDS: `${event}adjustingfunds`,
    FETCHING_EVENT_DIRECTOR_EVENTS: `${event}fetchingeventdirectorevents`,
    FETCH_EVENT_DIRECTOR_EVENTS: `${event}fetcheventdirectorevents`,
    FETCHING_EVENTS: `${event}fetchingevents`,
    FETCH_EVENTS: `${event}fetchevents`,
    DELETE_EVENT_DIVISION_OFFERED: `${event}deleteeventdivisionoffered`,
  },
  Center: {
    SEARCH_BY_NAME: `${event}SEARCH_CENTER_BY_NAME`,
    SEARCH_BY_NUMBER: `${event}SEARCH_CENTER_BY_NUMBER`,
    FETCH_CENTER: `${event}FETCH_CENTER`,
  },
  PostEvent: {
    OPT_OUT: `${postevent}optout`,
    COMPLETE_EVENT: `${postevent}completeevent`,
    COMPLETE_EVENT_ERROR: `${postevent}completeeventerror`,
    FETCH_POST_EVENT: `${postevent}fetchpostevent`,
    FETCHING_POST_EVENT: `${postevent}fetchingpostevent`,
    RESET_WIZARD_STATE: `${postevent}resetwizardstate`,
    RESET_POST_EVENT_WIZARD: `${postevent}resetposteventwizard`,
    UPLOADING_RESULTS_FILE: `${postevent}uploadingresultsfile`,
    UPLOAD_RESULTS_FILE: `${postevent}uploadresultsfile`,
    PRESTINE_NAVIGATE_NEXT: `${postevent}prestinenavigatenext`,
    SET_SEARCH_MODE: `${postevent}searchmode`,
    FETCH_MEMBER: `${postevent}fetchmember`,
    SAVING_ATHLETE: `${postevent}savingathlete`,
    SAVE_ADVANCER: `${postevent}saveadvancer`,
    UPDATE_ADVANCER: `${postevent}updateadvancer`,
    UPDATE_ALTERNATE: `${postevent}updatealternate`,
    UPDATE_ALTERNATES_ORDER: `${postevent}updatealternatesorder`,
    RESEND_ADVANCER_EMAIL: `${postevent}resendadvanceremail`,
    FETCH_ALTERNATE_PARENT_EMAIL: `${postevent}fetchalternateparentemail`,
    FETCH_ADVANCER_PARENT_EMAIL: `${postevent}fetchadvancerparentemail`,
    SAVE_ALTERNATE: `${postevent}savealternate`,
    DELETE_ADVANCER: `${postevent}deleteadvancer`,
    DELETE_ALTERNATE: `${postevent}deletealternate`,
    SAVE_FEE_PAYMENT: `${postevent}savefeepayment`,
    SAVE_FEE_PAYMENT_ERROR: `${postevent}savefeepaymenterror`,
    SAVING_FEE_PAYMENT: `${postevent}savingfeepayment`,
    ADD_MIXED_AGE_DIVISION: `${postevent}addmixedagedivision`,
    SAVE_POST_EVENT_SETUP: `${postevent}saveposteventsetup`,
    SAVE_POST_EVENT_SETUP_ERROR: `${postevent}saveposteventsetuperror`,
    SAVE_POST_EVENT_ADVANCERS: `${postevent}saveposteventadvancers`,
    SAVE_POST_EVENT_ADVANCERS_ERROR: `${postevent}saveposteventadvancerserror`,
    UPDATING_ATHLETES: `${postevent}updatingathletes`,
    DELETE_EVENT_DIVISION_HELD: `${postevent}deleteeventdivisionheld`,
    FETCHING_ADVANCERS: `${postevent}fetchingadvancers`,
    FETCH_ADVANCERS: `${postevent}fetchadvancers`,
    TRIGGERING_ADVANCER_PROCESS: `${postevent}triggeringadvancerprocess`,
    TRIGGER_ADVANCER_PROCESS: `${postevent}triggeradvancerprocess`,
  }
}

export { default as OrphanedEventActionTypes } from './action_orphanedevent'


// WEBPACK FOOTER //
// ./src/redux/actions/index.js